export default __webpack_public_path__ + "static/media/IconDropDown.2ff40eea.svg";